import { ctaDesc, ctaTitle } from "@/lib/seo";
import { createFileRoute, notFound } from "@tanstack/react-router";
import NaatiProductPage from "@/components/NaatiProductPage";
import { getNaatiProduct, NAATI_PRODUCTS } from "@/data/naati-products";
import { naatiProductGraph, defaultProductFaqs } from "@/lib/naati-product-schema";
import { BRAND_URL } from "@/lib/brand";

export const Route = createFileRoute("/naati/products/$sku")({
  loader: ({ params }) => {
    const p = getNaatiProduct(params.sku);
    if (!p) throw notFound();
    return { product: p };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) return { meta: [{ title: ctaTitle("ไม่พบสินค้า", "/naati/products/$sku", "th")}, { name: "robots", content: "noindex" }] };
    const p = loaderData.product;
    const path = `/naati/products/${params.sku}`;
    const url = `${BRAND_URL}${path}`;
    const title = `แปล ${p.nameTh} รับรอง NAATI ใช้ยื่นออสเตรเลีย | 5–7 วัน`;
    const desc = p.shortDescTh + " · รับรองโดยนักแปล NAATI CPN + ทนายไทย ตรวจก่อนประทับตราทุกฉบับ";
    const faqs = defaultProductFaqs(p, "th");
    return {
      meta: [
        { title: ctaTitle(title, "/naati/products/$sku", "th") }, { name: "description", content: ctaDesc(desc, "/naati/products/$sku", "th")},
        { property: "og:title", content: ctaTitle(title, "/naati/products/$sku", "th")},
        { property: "og:description", content: ctaDesc(desc, "/naati/products/$sku", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "product" },
        { property: "og:locale", content: "th_TH" },
        { property: "product:price:amount", content: "1900" },
        { property: "product:price:currency", content: "THB" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: url },
        { rel: "alternate", hrefLang: "en", href: `${BRAND_URL}/en/naati/products/${params.sku}` },
        { rel: "alternate", hrefLang: "x-default", href: url },
      ],
      scripts: [{
        type: "application/ld+json",
        children: JSON.stringify(naatiProductGraph({ product: p, locale: "th", path, faqs })),
      }],
    };
  },
  notFoundComponent: () => <div className="p-16 text-center">ไม่พบสินค้าที่ค้นหา</div>,
  component: () => {
    const { product } = Route.useLoaderData();
    return <NaatiProductPage product={product} locale="th" faqs={defaultProductFaqs(product, "th")} />;
  },
});

// Prebuild helper — exported so sitemap can enumerate.
export const NAATI_PRODUCT_SLUGS = NAATI_PRODUCTS.map((p) => p.slug);
